import { useAppSelector } from "app/redux/hooks"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import React, { useEffect, useState } from "react"
import { TratamentoMadeiraItemContainer } from "./TratamentoMadeiraItemContainer"

export type TratamentoMadeiraContainerProps = {
    somenteLeitura: boolean
    onCancelar: () => void
    onFinalizarConfiguracaoProdutos: () => void
}

export const TratamentoMadeiraContainer = (props: TratamentoMadeiraContainerProps) => {
    const [itensMadeiraNaoConfigurados, setItensMadeiraNaoConfigurados] = useState<IItemOrcamento[]>(null)
    const [itemAtual , setItemAtual] = useState<IItemOrcamento>(null)
    const [itemAtualIndex, setItemAtualIndex] = useState<number>(null)

    const orcamento = useAppSelector(store => store.orcamento)



    useEffect(() => {

        const itensMadeiraNaoCarregadosAinda = itensMadeiraNaoConfigurados == null
        const itensMadeiraNaoConfigurados_ = (orcamento.ItensOrcamento ?? []).filter(i => i.Madeira && i.DadosMadeira == null)
        setItensMadeiraNaoConfigurados(itensMadeiraNaoConfigurados_)

        if (itensMadeiraNaoConfigurados_.length == 0) {
            return
        }

        if (itensMadeiraNaoCarregadosAinda) {
            setItemAtual(itensMadeiraNaoConfigurados_[0])
            setItemAtualIndex(0)
        }

    },[])

    return <>
        {itensMadeiraNaoConfigurados == null && <>Carregando...</>}

        {itensMadeiraNaoConfigurados != null && itensMadeiraNaoConfigurados.length == 0 && <>Nenhum item de madeira encontrado</>}

        {itensMadeiraNaoConfigurados != null && itensMadeiraNaoConfigurados.length > 0 && itemAtual != null && <>
            <TratamentoMadeiraItemContainer
                item={itemAtual}
                onClose={props.onCancelar}
                onOk={() => {
                    if (itemAtualIndex == itensMadeiraNaoConfigurados.length - 1) {
                        props.onFinalizarConfiguracaoProdutos()
                    } else {
                        setItemAtual(() => null)
                        setItemAtual(() => itensMadeiraNaoConfigurados[itemAtualIndex + 1])
                        setItemAtualIndex(itemAtualIndex + 1)
                    }
                }}
                somenteLeitura={props.somenteLeitura}
                />
        </>}
    </>
}
